import React, { createContext, useContext, useState, useCallback } from "react";
import { supabase } from "../lib/supabase";
import { Series } from "../lib/supabase";
import toast from "react-hot-toast";

interface SeriesContextType {
  refreshSeries: (id: string) => Promise<Series | null>;
}

const SeriesContext = createContext<SeriesContextType | undefined>(undefined);

export const SeriesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const refreshSeries = useCallback(async (id: string): Promise<Series | null> => {
    try {
      const { data, error } = await supabase
        .from("series")
        .select("*")
        .eq("id", id)
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error refreshing series:", error);
      toast.error("Failed to refresh series data");
      return null;
    }
  }, []);

  return (
    <SeriesContext.Provider value={{ refreshSeries }}>
      {children}
    </SeriesContext.Provider>
  );
};

export const useSeries = () => {
  const context = useContext(SeriesContext);
  if (context === undefined) {
    throw new Error("useSeries must be used within a SeriesProvider");
  }
  return context;
};